module.exports = __webpack_public_path__ + "img/scb-icon.d7ef93e7.png";